import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { selectPageServices } from 'state/selectors/currentUserSelectors';
import _ from 'lodash';
import { I18N } from 'commons';
import ErrorMessage from '../ErrorMessage';
import {convertHTMLTags} from 'utils'

const PinExtInputPagerService = ({
  contactPath,
  onChange,
  pageServices,
  setIsNeedValidation,
  setFieldTouched,
  setContactPathError,
  contactPathError,
  touched,
  mandatory,
}) => {
  const { pathId, phoneExt, ext, pin, pathType, systemRequirement, editable, name: pathName } = contactPath;
  const { value: phoneValue } = contactPath;
  const inputName = `contactPath--${pathId}`;
  const hasPagerServiceTouched = _.has(touched, 'pagerService');
  const hasPagerServiceError = Boolean(contactPathError.pagerService);
  const handlePinExtEvent = (e) => {
    const PinExtRegExp = /^[0-9]*$/;
    const { value } = e.target;
    if (value) {
      onChange({
        phoneExt: value,
      });
      const { name } = e.target;
      const isPin = /^pin_/.test(name);
      let componentId;
      if (isPin) {
        componentId = `pin_${pathId}`;
      } else {
        componentId = `ext_${pathId}`;
      }
      if (!PinExtRegExp.test(value)) {
        setFieldTouched(componentId, true);
        setContactPathError(componentId, (isPin) ? 'jquery.validation.pin' : 'jquery.validation.ext');
      } else {
        setContactPathError(componentId, 'delete');
      }
      if ((!contactPathError[inputName] && !phoneValue)) {
        setFieldTouched(inputName, true);
        setContactPathError(inputName, `jquery.validation.field.required,${convertHTMLTags(pathName)}`);
      }
    } else {
      onChange({
        phoneExt: value,
      });
      if (!mandatory && !phoneValue) {
        setContactPathError(inputName, 'delete');
      }
    }
    setIsNeedValidation(false);
  };
  return (
    <div>
      {
        pin &&
        <div className="row margin10-T">
          <label
            htmlFor={`pin_${pathId}`}
            id={`${pathId}PinLabel`}
            className="col-6 col-form-label text-right"
          >
            <I18N>template.myprofile.deliverypath.pin</I18N>
          </label>
          <div className="col-6">
            <I18N
              tag="input"
              autoComplete="off"
              id={`pin_${pathId}`}
              name={`pin_${pathId}`}
              type="text"
              className="form-control"
              maxLength="10"
              value={phoneExt || ''}
              phoneext="true"
              disabled={!editable}
              onChange={handlePinExtEvent}
              onBlur={handlePinExtEvent}
            />
            {
              contactPathError[`pin_${pathId}`] &&
              <ErrorMessage role="alert" aria-live="assertive">jquery.validation.pin</ErrorMessage>
            }
          </div>
        </div>
      }
      {
        ext &&
        <div className="row margin10-T">
          <label id={`${pathId}ExtLabel`} htmlFor={`ext_${pathId}`} className="col-6 col-form-label text-right">
            <I18N>template.myprofile.deliverypath.ext</I18N>
          </label>
          <div className="col-6">
            <I18N
              tag="input"
              autoComplete="off"
              id={`ext_${pathId}`}
              name={`ext_${pathId}`}
              type="text"
              className="form-control"
              maxLength="10"
              value={phoneExt || ''}
              phoneext="true"
              disabled={!editable}
              onChange={handlePinExtEvent}
              onBlur={handlePinExtEvent}
            />
            {
              contactPathError[`ext_${pathId}`] &&
              <ErrorMessage role="alert" aria-live="assertive">jquery.validation.ext</ErrorMessage>
            }
          </div>
        </div>
      }

      {
        (pathType === 'NUMERICPAGER' || pathType === 'PLAINTEXTEMAIL') &&
        <div className="row margin10-T">
          <label
            htmlFor={`pagerService_${pathId}`}
            className="col-6 col-form-label text-right"
            id={`${pathId}PagerLabel`}
          >
            <I18N>template.myprofile.deliverypath.pagerservice</I18N>
          </label>
          <div className="col-6">
            <select
              id={`pagerService_${pathId}`}
              name={`pagerService_${pathId}`}
              defaultValue={systemRequirement}
              className={classnames('form-control valid', (mandatory) ? 'js_blur' : '')}
              disabled={!editable}
              aria-invalid={hasPagerServiceTouched && hasPagerServiceError}
              aria-describedby={(contactPathError[`pagerService_${pathId}`]) ? `${pathId}PagerDesc` : null}
              onChange={(e) => {
                const { value } = e.target;
                setFieldTouched(`pagerService_${pathId}`, true);
                setContactPathError(`pagerService_${pathId}`, 'delete');
                if (value !== 'select') {
                  onChange({
                    systemRequirement: value,
                  });
                  if (!contactPathError[inputName] && !phoneValue) {
                    setFieldTouched(inputName, true);
                    setContactPathError(inputName, `jquery.validation.field.required, ${convertHTMLTags(pathName)}`);
                  }
                } else {
                  onChange({
                    systemRequirement: value,
                  });
                  if (mandatory && phoneValue) {
                    setFieldTouched(`pagerService_${pathId}`, true);
                    setContactPathError(`pagerService_${pathId}`, `jquery.validation.field.required, ${convertHTMLTags(pathName)}`);
                  }
                }
                setIsNeedValidation(false);
              }}
              onBlur={(e) => {
                if (!mandatory) {
                  return;
                }
                const { value } = e.target;
                setFieldTouched(`pagerService_${pathId}`, true);
                setContactPathError(`pagerService_${pathId}`, 'delete');
                if (value !== 'select' && !contactPathError[inputName] && !phoneValue) {
                  setFieldTouched(inputName, true);
                  setContactPathError(inputName, `jquery.validation.field.required, ${convertHTMLTags(pathName)}`);
                } else if (value == 'select' && phoneValue) {
                  setFieldTouched(`pagerService_${pathId}`, true);
                  setContactPathError(`pagerService_${pathId}`, `jquery.validation.field.required, ${convertHTMLTags(pathName)}`);
                }
                setIsNeedValidation(false);
                const { nativeEvent } = e;
                if (nativeEvent && nativeEvent.formSubmit) {
                  const { formSubmit } = nativeEvent;
                  formSubmit[`pagerService_${pathId}`] = true;
                  const { validationCtrl: { size, resolver } } = nativeEvent;
                  const { length } = Object.keys(formSubmit);
                  if (length === size) {
                    resolver();
                  }
                }
              }
              }
            >
              <I18N tag="option" className="ng-binding" value="">
                ssp.select.null.text
              </I18N>
              {
                pageServices.map((item, index) =>
                  (
                    <option value={item.name} key={`${item.id}-${index}`}>
                      {item.name}
                    </option>
                  )
                )
              }
            </select>
            {contactPathError[`pagerService_${pathId}`] && (
              <ErrorMessage id={`${pathId}PagerDesc`} role="alert" aria-live="assertive">
                {contactPathError[`pagerService_${pathId}`]}
              </ErrorMessage>
            )}
          </div>
        </div>
      }

    </div>
  );
};

PinExtInputPagerService.propTypes = {
  contactPath: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  pageServices: PropTypes.arrayOf(PropTypes.shape()),
  setIsNeedValidation: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setContactPathError: PropTypes.func.isRequired,
  contactPathError: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  mandatory: PropTypes.bool.isRequired,
};
PinExtInputPagerService.defaultProps = {
  pageServices: [{}],
};
const mapStateToProps = state => ({
  pageServices: selectPageServices(state),
});

export default connect(mapStateToProps)(PinExtInputPagerService);
